import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import Utils from "../../commons/utils/utils";
import Http from "../../commons/utils/Http";
import Message from "../../commons/utils/message"
import ButtonAction from "../../commons/components/buttonAction";
import AccountTable from "../../commons/components/AccountTable"
import AccountModal from "../../commons/components/AccountModal"

import CertificationModal from "./CertificationModal/certificationModal"
import {
    setShowCertificationModal,
    setModeCertificationModal,
    setSelectedCertification,
} from '../../store/actions/certificationActions';
import certificationModalModes from './CertificationModal/certificationModalModes'

import Permissions from "../../commons/utils/permissions"

function DataTable(props) {
    const dispatch = useDispatch();
    const { selectedUser, selectedCertification } = useSelector((state) => state.certification);
    const { screens } = useSelector(state => state.userLogin);
    const [permissions] = useState([]);

    const [tableData, setTableData] = useState([]);
    const [tableLoading, setTableLoading] = useState(true);
    const [pagination, setPagination] = useState(
        {
            current: 1,
            pageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ['5', '10', '15', '20'],
            //position: ['bottomLeft']
        }
    );
    const [sorter, setSorter] = useState({ field: "certificate_name", order: "ascend" });
    const [search, setSearch] = useState("");
    const [filters, setFilters] = useState({});

    const [showModalDelete, setShowModalDelete] = useState(false);

    const tableColumns = [
        {
            title: 'Código',
            dataIndex: 'certificate_id',
            key: 'certificate_id',
            sorter: true,
            width: '10%',
            ellipsis: true,
        },
        {
            title: 'Descrição',
            dataIndex: 'certificate_name',
            key: 'certificate_name',
            sorter: true,
            defaultSortOrder: 'ascend',
            width: '20%',
            ellipsis: true,
        },
        {
            title: 'Dt. Certificação',
            dataIndex: 'certificate_date',
            key: 'certificate_date',
            sorter: true,
            width: '10%',
            ellipsis: true,
        },
        {
            title: 'Observação',
            dataIndex: 'observation',
            key: 'observation',
            sorter: true,
            width: '20%',
            ellipsis: true,
        },
        {
            title: 'Nota',
            dataIndex: 'grade',
            key: 'grade',
            sorter: true,
            width: '10%',
            ellipsis: true,
        },
        {
            title: 'Dt. Validade',
            dataIndex: 'expiration_date',
            key: 'expiration_date',
            sorter: true,
            width: '10%',
            ellipsis: true,
        },
        {
            title: 'Dt. Alteração',
            dataIndex: 'update_date',
            key: 'update_date',
            sorter: true,
            width: '10%',
            ellipsis: true,
        },
        {
            title: 'Ação',
            key: 'action',
            width: '10%',
            ellipsis: true,
            align: "center",
            render: (text, certification) => (
                <div style={{ display: 'flex', justifyContent: "center", alignItems: "center" }}>
                    {(permissions.find(_function => _function.function_id === Permissions.EDITAR_CERTIFICACAO)) ?
                        <ButtonAction type="edit" text="Editar Certificação" callback={() => handleEditCertification(certification)} />
                        : null
                    }
                    {(permissions.find(_function => _function.function_id === Permissions.EXCLUIR_CERTIFICACAO)) ?
                        <ButtonAction type="delete" text="Excluir Certificação" callback={() => handleDeleteCertification(certification)} />
                        : null
                    }
                    {(permissions.find(_function => _function.function_id === Permissions.VISUALIZAR_CERTIFICACAO) &&
                        !permissions.find(_function => _function.function_id === Permissions.EDITAR_CERTIFICACAO)) ?
                        <ButtonAction type="view" text="Visualizar Certificação" callback={() => handleViewCertification(certification)} />
                        : null
                    }
                </div>
            ),
        }
    ];

    useEffect(() => {
        if (screens.length > 0) {
            screens.map(screen => {
                if (screen.url === "/certifications") {
                    screen.functions.map(func => {
                        permissions.push(func)
                    })
                }
            });
        }

    }, [screens]);

    useEffect(() => {
        if (selectedUser.id) {
            getCertifications(pagination, sorter);
        }
    }, [selectedUser]);

    function getCertifications(pagination, sorter) {
        const order = getOrder(sorter);
        const offset = pagination.current;
        const lines = pagination.pageSize;

        setTableLoading(true);
        Http.get(`/users/get-certifications?id=${selectedUser.id}&offset=${offset}&order=${order}&lines=${lines}`, Http.headers)
            .then(response => {
                const responseData = response.data
                if (!responseData.response.error) {
                    formatTable(responseData.data)
                    setPagination({ ...pagination, total: responseData.pagination });
                    setTableLoading(false);
                }
            }).catch(err => {
                setTableData([]);
                setTableLoading(false);
            })
    }

    function deleteCertification(data) {
        let body = {
            "certification_id": data.id,
            "delete": true
        }

        Http.put(`/users/update-user-certification`, body, Http.headers)
            .then(response => {
                const responseData = response.data.response
                if (!responseData.error) {
                    getCertifications(pagination, sorter);
                    dispatch(setSelectedCertification({}));
                    setShowModalDelete(false);
                    Message.showInfo(response.data.response.message)
                }
            }).catch(err => {
                Message.showError(err.response.data.response.message);
            })
    }

    function formatTable(data) {
        let array = [];
        data.forEach((certification) => {
            certification.certificate_date = Utils.formatDate(certification.certificate_date);
            certification.expiration_date = Utils.formatDate(certification.expiration_date);
            certification.update_hour = Utils.formatHour(certification.update_date);
            certification.update_date = Utils.formatDate(certification.update_date);
            array.push(certification)
        })
        setTableData(array);
    }

    function getOrder(sorter) {
        switch (sorter.order) {
            case 'ascend':
                return sorter.field + ' asc'
            case 'descend':
                return sorter.field + ' desc'
            default:
                return sorter.field
        }
    }

    function handleOnChangeTable(pagination, filters, sorter, currentPageData) {
        setSorter(sorter);
        setFilters(filters);
        getCertifications(pagination, sorter);
    }

    function handleConfirmDeleteCertification() {
        deleteCertification(selectedCertification);
    }

    function handleCancelDeleteCertification() {
        dispatch(setSelectedCertification({}));
        setShowModalDelete(false);
    }

    function handleDeleteCertification(certification) {
        dispatch(setSelectedCertification(certification));
        setShowModalDelete(true);
    }

    function handleOnSaveCertificationModal() {
        getCertifications(pagination, sorter);
    }

    function handleViewCertification(certification) {
        dispatch(setSelectedCertification(certification));
        dispatch(setModeCertificationModal(certificationModalModes.VIEW));
        dispatch(setShowCertificationModal(true));
    }

    function handleEditCertification(certification) {
        dispatch(setSelectedCertification(certification));
        dispatch(setModeCertificationModal(certificationModalModes.EDIT));
        dispatch(setShowCertificationModal(true));
    }

    function handleInsertCertification() {
        dispatch(setModeCertificationModal(certificationModalModes.INSERT));
        dispatch(setShowCertificationModal(true));
    }

    const renderAddCertificationButton = () => {
        if (permissions.find(_function => _function.function_id === Permissions.CADASTRAR_CERTIFICACAO)) {
            return (
                <div style={{ marginTop: 16, textAlign: "right" }}>
                    <button onClick={handleInsertCertification} className={"account-button account-button-default"}>
                        Adicionar certificação
                    </button>
                </div>
            )
        }
    };

    return (
        <>
            {renderAddCertificationButton()}

            <AccountTable
                columns={tableColumns}
                dataSource={tableData}
                pagination={pagination}
                loading={tableLoading}
                onChange={handleOnChangeTable}
            />

            <CertificationModal onSave={handleOnSaveCertificationModal} />

            <AccountModal
                visible={showModalDelete}
                title="Excluir Certificação"
                onCancel={handleCancelDeleteCertification}
                cancelText="Cancelar"
                onOk={handleConfirmDeleteCertification}
                okText="Excluir"
                okType="danger">

                <p>Tem certeza que deseja excluir esta certificação?</p>
                <small><strong><p>Após concluída, essa ação não poderá ser desfeita.</p></strong></small>
            </AccountModal>
        </>
    )
}

export default DataTable;
